<template>
    <v-col cols="6" sm="4" md="3" lg="2" xl="2" class="pa-2">
        <v-card :style="{'border': collection.collected ? '3px solid #03a9f4 !important' : 'unset'}"
                :dark="collection.state !== 'W' && collection.state !== 'K' && collection.state !== 'L'"
                :color="state_color" elevation="3">
            <v-container fluid class="py-0">
                <v-row align="center">
                    <v-col cols="9" class="pa-0">
                        <span class="font-weight-medium pl-2">
                            {{ collection.state_display }}
                        </span>
                    </v-col>
                </v-row>
            </v-container>
            <v-img
                class="card-img-top"
                @click="onShowImage"
                style="cursor: pointer; "
                :src="collection.image_url"></v-img>
            <v-card-title class="pa-2 py-0">
                <span v-if="collection.purchase">Сбор №{{ collection.number }}</span>
                <span v-else>Не в закупке</span>
            </v-card-title>
            <v-container class="py-0 px-2 mt-n1" fluid>
                <v-row align="start" justify="center">
                    <v-col cols="12" v-if="collection.collected" class="py-1">
                        <v-sheet elevation="3" dark class="light-blue text-center">
                            Собран
                        </v-sheet>
                    </v-col>
                    <v-col cols="12" v-if="collection.prepayment_value > 0" class="py-1">
                        <v-sheet @click="onShowCheck" elevation="3" dark class="primary text-center pa-1"
                                 style="line-height: 17px; cursor: pointer">
                            <div>Предоплата поставщику {{ collection.prepayment_value }}₽</div>
                            <div class="caption mt-n1">(Показать чек)</div>
                        </v-sheet>
                    </v-col>
                    <v-col v-if="collection.state_comment" cols="12" class="py-1">
                        <v-sheet elevation="3" dark class="secondary text-center">
                            {{ collection.state_comment }}
                        </v-sheet>
                    </v-col>
                </v-row>
            </v-container>
            <v-card-subtitle class="px-2 pt-0 pb-1 subtitle-1" style="line-height: 1.2">
                <div class="mb-2">{{ collection.description }}</div>
                <div style="font-size: 14px" class="font-weight-medium" v-for="(position_info, index) in positions_info"
                     :key="index">{{ position_info }}
                </div>
            </v-card-subtitle>
            <v-divider class="mx-2"/>
            <div v-if="!opened_link.additional.hide_price">
                <v-card-text class="pa-0 pt-1 pl-2">
                    {{ collection.trade_price }}
                    <v-icon small style="position: relative; bottom: 1px; right: 6px">{{ icon_rub }}</v-icon>
                    <v-icon size="13" style="position: relative; bottom: 2px; right: 5px">{{ icon_mul }}</v-icon>
                    <span :class="{'count': collection_count > 1}">{{ collection_count }}шт.</span>
                    <span v-show="collection.prepayment_value > 0">
                    - {{ collection.prepayment_value }}
                    <v-icon small style="position: relative; bottom: 1px; right: 6px">{{ icon_rub }}</v-icon>
                </span>
                </v-card-text>
                <v-card-title class="px-2 py-0 mt-n1">
                    = {{ total_price }}
                    <v-icon size="19.5" style="position: relative; right: 4px; bottom: 0.5px;">{{ icon_rub }}</v-icon>
                </v-card-title>
            </div>
            <div v-else>
                <v-card-title class="px-2">
                    Итого <span class="ml-2" :class="{'count': collection_count > 1}">{{ collection_count }}шт.</span>
                </v-card-title>
            </div>
            <v-divider class="mx-2"></v-divider>
            <v-container fluid class="px-4 pb-2 pt-0">
                <v-row align="center" justify="center">
                    <v-col v-if="collection.collected" cols="12" class="pa-0 px-1 pt-2 text-center">
                        <v-btn @click="onToggleCollected" width="100%" :loading="toggle_collected_loading" rounded
                               class="secondary caption text-none">
                            НЕ СОБРАН
                        </v-btn>
                    </v-col>
                    <v-col v-else cols="12" class="pa-0 px-1 pt-2 text-center">
                        <v-btn @click="onToggleCollected" width="100%" :loading="toggle_collected_loading" rounded
                               class="primary caption text-none">
                            СОБРАН
                        </v-btn>
                    </v-col>
                </v-row>
            </v-container>
        </v-card>
    </v-col>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import {
    mdiCurrencyRub, mdiMultiplication
} from "@mdi/js";
import EventBus from "../../event-bus";

export default {
    name: "SharedCollection",
    props: {
        album_id: {
            default: undefined
        },
        collection: {
            required: true,
        },
        index: {
            required: true,
        }
    },
    data() {
        return {
            icon_rub: mdiCurrencyRub,
            icon_mul: mdiMultiplication,

            toggle_collected_loading: false,
        }
    },
    computed: {
        ...mapGetters('links', [
            'opened_link'
        ]),
        positions_info() {
            let dict = {}
            this.collection.positions.forEach(obj => {
                if (!obj.client) return
                const name = obj.name || '—'
                if (name in dict) {
                    dict[name] += obj.count
                } else {
                    dict[name] = obj.count
                }
            })
            let final = []
            for (const [key, value] of Object.entries(dict)) {
                final.push(`${key} [${value}шт]`)
            }
            return final
        },
        state_color: function () {
            switch (this.collection.state) {
                case 'P':
                    return 'green';
                case 'C':
                    return 'red';
                case 'O':
                    return 'info';
                default:
                    return 'white'
            }
        },
        collection_count() {
            let result = 0;
            this.collection.positions.forEach(obj => {
                if (obj.state !== 'C' || this.state === 'C') {
                    if (this.album_id !== undefined && obj.album === parseInt(this.album_id)) {
                        result += obj.count
                    } else if (obj.client !== undefined && obj.client !== null && (this.album_id === undefined || this.album_id === null)) {
                        result += obj.count
                    }
                }
            })
            return result;
        },
        total_price() {
            const prepayment_value = this.collection.prepayment_value;
            return this.collection.trade_price *
                this.collection_count - (this.album_id === undefined ? prepayment_value : 0) +
                (this.album_id !== undefined ? this.collection_percent : 0);
        }
    },
    methods: {
        ...mapActions('collections', [
            'toggleCollected',
        ]),
        onToggleCollected() {
            this.toggle_collected_loading = true;
            this.toggleCollected({collection_id: this.collection.id, uuid: this.opened_link.uuid})
                .then(() => {
                    this.toggle_collected_loading = false;
                })
                .catch(() => {
                    this.toggle_collected_loading = false;
                })
        },
        onShowCheck() {
            EventBus.$emit('image_dialog', this.collection.prepayment_check_url)
        },
        onShowImage() {
            EventBus.$emit('image_dialog', this.collection.image_url)
        }
    }
}
</script>


<style scoped>

/*.count {*/
/*    background-color: #1976d2 !important;*/
/*    color: white;*/
/*    padding: 1px 5px;*/
/*    margin-right: 2px;*/
/*    border-radius: 3px;*/
/*}*/

@media (max-width: 600px) {
    .card-img-top {
        height: 45vw;
    }
}

@media (min-width: 600px) {
    .card-img-top {
        height: 30vw;
    }
}

@media (min-width: 960px) {
    .card-img-top {
        height: 25vw;
    }
}

@media (min-width: 1264px) {
    .card-img-top {
        height: 15vw;
    }
}

</style>